var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.classes,attrs:{"disabled":_vm.isFetchingToken,"type":"submit"},domProps:{"value":_vm.value},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }